export default __webpack_public_path__ + "static/media/usf.a41306e9.png";